export default __webpack_public_path__ + "static/media/reseller-form.865a3283.pdf";